import React, { useEffect, useState } from "react";
import { Tree, Spin, Input, Button, message } from "antd";
import stationApi from "@/api/station";
import Analysisapi from "@/api/analysis";
import './style.scss'

// 递归转换为Antd Tree所需结构
function convertTreeData(data) {
  return (data || []).map((item) => ({
    title: item.itemName,
    key: item.id,
    children: convertTreeData(item.child),
    isLeaf: !item.child || item.child.length === 0,
    deviceId: item.deviceId,
    raw: item,
  }));
}

export default function Collocate() {
  const [currentType, setCurrentType] = useState('');
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [energyConfig, setEnergyConfig] = useState([]); // 右侧能耗配置（已配）
  const [inputValues, setInputValues] = useState([]);
  const [saving, setSaving] = useState(false);
  const [energyIconMap, setEnergyIconMap] = useState([]); // energyIcon映射配置

  // 页面加载时获取树和energyIcon映射
  useEffect(() => {
    setLoading(true);
    selectEnergyList()
  }, []);

  useEffect(()=>{
    if(currentType){
      getEnergyDlDyPointList()
    }
  }, [currentType])

  const [lineTypeList, setLineTypeList] = useState([]);
  const selectEnergyList = () => {
    Analysisapi.selectEnergyList().then((res) => {
      if (res.status == 0 && res.data) {
        setLineTypeList(res.data);
        if(res.data.length > 0){
          setCurrentType(res.data[0].id)
        }
      }
    });
  }
  const getEnergyDlDyPointList = () =>{
    setDataLoading(true)
    Analysisapi.getEnergyDlDyPointList(currentType).then((res) => {
      if (res.status == 0 && res.data) {
        setEnergyIconMap(res.data);
      }
    }).finally(() => {
      setDataLoading(false)
    })
  }

  const selectType = (id) => {
    setCurrentType(id)
  }

  // 输入框变化
  const handleInputChange = (iconItem, newValue) => {
    // 关键逻辑：通过map生成新数组，匹配项修改value，其余保持不变
    const newEnergyIconMap = energyIconMap.map(item => {
      // 以唯一标识gatherDevId匹配当前修改的项（与key值一致，避免错误）
      if (item.gatherDevId === iconItem.gatherDevId) {
        return { ...item, value: newValue }; // 解构原对象，仅更新value（不可变修改）
      }
      return item; // 非匹配项直接返回，保持不变
    });
    // 更新状态，触发组件重新渲染
    setEnergyIconMap(newEnergyIconMap);
  };

  // 保存按钮，调用renewDeviceEnergyConfig接口
  const handleSave = async () => {
    setSaving(true);
    const params = energyIconMap.reduce((ary, item)=>{
      ary.push({
        gatherDevId: item.gatherDevId,
        value: item.value
      })
      return ary
    }, [])
    try {
      const res = await Analysisapi.updateEnergyDlDyPoint(params);
      if (res.status === "0") {
        message.success("保存成功");
      } else {
        message.error(res.msg || "保存失败");
      }
    } catch (e) {
      message.error("保存失败");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        background: "#fff",
        padding: 24,
        minHeight: 500,
        height: "100%",
      }}
    >
      <div
        style={{
          width: 280,
          borderRight: "1px solid #f0f0f0",
          paddingRight: 24,
          overflow: "auto",
          height: "100%",
        }}
      >
        {
          lineTypeList.map((item)=>(
            <div onClick={()=>selectType(item.id)} className={`line-type-item ${item.id === currentType ? 'line-type-item-active' : ''}`}  key={item.id}>{item.name}</div>
          ))
        }
      </div>
      <div
        style={{
          flex: 1,
          paddingLeft: 32,
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        <Spin spinning={dataLoading}>

        {
          (energyIconMap.length > 0 ? (
            <div className="energy-icon-map">
              {energyIconMap.map((iconItem) => (
                <div
                  key={iconItem.gatherDevId}
                  style={{
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  <span style={{ width: 120, textAlign: "right",marginRight: '10px' }}>{iconItem.name}</span>
                  <Input
                    style={{ width: 300 }}
                    value={iconItem.value}
                    onChange={(e) =>
                      handleInputChange(iconItem, e.target.value)
                    }
                    placeholder="请输入采集变量"
                  />
                </div>
              ))}
              <div className="btn-row" style={{ marginTop: 32 }}>
                <Button
                  type="primary"
                  loading={saving}
                  onClick={handleSave}
                  style={{ marginRight: 16 }}
                >
                  保存
                </Button>
                <Button
                  onClick={() =>
                    setInputValues((prev) => {
                      const reset = {};
                      energyIconMap.forEach((item) => {
                        reset[item.energyIcon] =
                          (
                            energyConfig.find(
                              (cfg) => cfg.energyIcon === item.energyIcon
                            ) || {}
                          ).energyName || "";
                      });
                      return reset;
                    })
                  }
                >
                  取消
                </Button>
              </div>
            </div>
          ) : (
            <div
              style={{
                color: "#999",
                fontSize: 16,
                marginTop: 32,
                textAlign: "center",
              }}
            >
              暂无数据
            </div>
          ))}
        </Spin>
      </div>
    </div>
  );
}
